import { render, staticRenderFns } from "./ConsultingMessage.vue?vue&type=template&id=86e501ac&scoped=true"
import script from "./ConsultingMessage.vue?vue&type=script&lang=js"
export * from "./ConsultingMessage.vue?vue&type=script&lang=js"
import style0 from "./ConsultingMessage.vue?vue&type=style&index=0&id=86e501ac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e501ac",
  null
  
)

export default component.exports